import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';

function Expandable() {
    // Assume that the animation time is 250 ms. This number needs to be kept in sync with the animate-height css declaration
    let animationLength = 250;

    //Force layout calculation
    this._afterLayout = function (action) {
        this.$node.outerHeight();
        action();
    };

    this._startAnimationTimer = function () {
        let afterAnimation = $.Deferred();
        let animationTimer;

        if (this.previousAnimation) {
            this.previousAnimation.reject();
        }
        this.previousAnimation = afterAnimation;

        animationTimer = setTimeout(function () { afterAnimation.resolve(); }, animationLength);
        afterAnimation.always(function () {
            clearTimeout(animationTimer);
        });

        return afterAnimation;
    };

    this._toggle = function (event, data) {
        let target = this.$node;
        let elementHeight;
        let afterAnimation = this._startAnimationTimer();

        afterAnimation.always(function () {
            target.removeClass('animate-height').css('height', 'auto');
        });

        if (data.expand) {
            target.addClass('visible').removeClass('animate-height').css('height', 0).addClass('visible');
            this._afterLayout(function () {
                elementHeight = target.children().outerHeight(true);
                target.addClass('animate-height').css('height', elementHeight);
            });
        } else {
            elementHeight = target.children().outerHeight(true);
            target.removeClass('animate-height').css('height', elementHeight);
            this._afterLayout(function () {
                target.addClass('animate-height').css('height', 0);
            });
            afterAnimation.always(function () {
                target.removeClass('visible');
            });
        }
    };

    this.after('initialize', function () {
        let context = this.$node.data('expandable');
        this.on(document, 'ui:toggle:' + context, this._toggle);
    });
}

export default defineComponent.component(Expandable);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/expandable.js